import { Container, AppHeader, Typography, Button, ButtonGroup } from '@ace-clublabs/shared-component-library';
import mantenancePageImg from '../assets/maintenance_page.png';
import { ExternalCTAs } from '../utils/constants';

interface IMantenancePageProps {}

export const MaintenancePage: React.FC<IMantenancePageProps> = (props: IMantenancePageProps) => {
  const onClickBtn = () => {
    window.location.href = ExternalCTAs.Account;
  };

  return (
    <Container maxWidth="sm">
      <AppHeader />

      <img
        src={mantenancePageImg}
        className="maintenance-page-img"
        alt="maintenance-page-img"
        style={{ width: '100%', marginBottom: '0.5rem' }}
      />

      <Typography
        className="maintenance-page-title"
        variant="h5"
        sx={{ fontWeight: '500', color: '#404040', marginBottom: '1rem' }}
      >
        We’re working on improvements
      </Typography>
      <Typography
        className="maintenance-page-description"
        variant="body1"
        sx={{ fontWeight: '400', color: '#404040', marginBottom: '1rem' }}
      >
        Our system is currently undergoing maintenance to improve your experience. Please check back later and we
        apologize for any inconvenience.
      </Typography>

      <ButtonGroup>
        <Button className="maintenance-page-button" onClick={onClickBtn} label="My Account" fullWidth />
      </ButtonGroup>
    </Container>
  );
};
